export const AUTH_USER = 'auth_user';
export const AUTH_SUCCESS = 'success';
export const AUTH_ERROR = 'auth_error';
export const USER = 'user';
export const ARTFORM_TYPES = 'artform success';
export const EVENT_TYPES = 'event type success';